import { ReviewType } from "src/api/types";
import reviewerFemale1 from "src/assets/reviewerFemale1.jpg";
import reviewerMale1 from "src/assets/reviewerMale1.png";
import reviewerAlejandro from "src/assets/patient-reviews/alejandro.png";
import reviewerDavid from "src/assets/patient-reviews/david.png";
import reviewerDiego from "src/assets/patient-reviews/diego.png";
import reviewerSofia from "src/assets/patient-reviews/sofia.png";
import reviewerChristopher from "src/assets/patient-reviews/christopher.png";
import reviewerAmanda from "src/assets/patient-reviews/amanda.png";
import reviewerIsabella from "src/assets/patient-reviews/isabella.png";
import reviewerJessica from "src/assets/patient-reviews/jessica.png";
import reviewerJames from "src/assets/patient-reviews/james.png";

export const reviews: ReviewType[] = [
  {
    page: "payment-information",
    id: 1,
    name: "Jessica R.",
    product: ["st", "st-ot", "tr", "tr-ot", "iwl-ot", "wp-ot", "os-ot"],
    gender: "female",
    location: "Boca Raton, FL",
    text: "“I’ve been a member for 6 months & lost 32 pounds so far and feel better than ever! My care team is always there for me when i need them.”",
    image: reviewerJessica,
  },
  {
    page: "payment-information",
    id: 2,
    name: "Sofía R.",
    product: ["st", "st-ot", "tr", "tr-ot", "iwl-ot", "wp-ot", "os-ot"],
    gender: "female",
    location: "Tampa, FL",
    text: "“I’m a working mom, constantly juggling everything and somehow this still worked. 16 pounds down and I have more energy now.”",
    image: reviewerSofia,
  },
  {
    page: "payment-information",
    id: 3,
    name: "Amanda T.",
    product: ["st", "st-ot", "tr", "tr-ot", "iwl-ot", "wp-ot", "os-ot"],
    gender: "female",
    location: "Hollywood, FL",
    text: "“I wasn’t looking for a quick fix, I needed something real. The support helped me lose 29 pounds and I actually feel like this is worth it.”",
    image: reviewerAmanda,
  },
  {
    page: "payment-information",
    id: 4,
    name: "Isabella L.",
    product: ["st", "st-ot", "tr", "tr-ot", "iwl-ot", "wp-ot", "os-ot"],
    gender: "female",
    location: "Jacksonville, FL",
    text: "“Very happy that i’m down 12 kilos! It’s been super easy to stay on track with how helpful the team is. Honestly, I didn’t think it would work this well.”",
    image: reviewerIsabella,
  },
  {
    page: "payment-information",
    id: 5,
    name: "Diego T.",
    product: ["st", "st-ot", "tr", "tr-ot", "iwl-ot", "wp-ot", "os-ot"],
    gender: "male",
    location: "Pensacola, FL",
    text: "“Work got hectic and my health took a back seat. This helped me get back on track & 31 pounds down, better focus, and more energy for everything.”",
    image: reviewerDiego,
  },
  {
    page: "payment-information",
    id: 6,
    name: "Christopher H.",
    product: ["st", "st-ot", "tr", "tr-ot", "iwl-ot", "wp-ot", "os-ot"],
    gender: "male",
    location: "Tallahassee, FL",
    text: "“Between work, parenting, and everything else, I didn’t think I had time for this. But I lost 38 pounds and more happy. Totally doable.”",
    image: reviewerChristopher,
  },
  {
    page: "payment-information",
    id: 7,
    name: "David W.",
    product: ["st", "st-ot", "tr", "tr-ot", "iwl-ot", "wp-ot", "os-ot"],
    gender: "male",
    location: "Fort Lauderdale, FL",
    text: "“No crash diets, no crazy routines just steady progress. I’ve lost 23 pounds and I’m eating in a way that actually makes me happy.”",
    image: reviewerDavid,
  },
  {
    page: "payment-information",
    id: 8,
    name: "Alejandro D.",
    product: ["st", "st-ot", "tr", "tr-ot", "iwl-ot", "wp-ot", "os-pt"],
    gender: "male",
    location: "St. Petersburg, FL",
    text: "“I was tired of feeling stuck. Losing 19 kilos gave me momentum not just physically but also mentally. It’s been the reset I didn’t know I needed.”",
    image: reviewerAlejandro,
  },
  {
    page: "reviews",
    id: 9,
    gender: "female",
    product: ["st", "st-ot", "iwl-ot", "wp-ot", "os-ot"],
    name: "Maria G.",
    location: "Tampa, FL",
    image: reviewerFemale1,
    text: `"Semaglutide changed everything for me. I've lost 41 pounds, feel stronger and healthier, and finally feel confident everyday."`,
  },
  {
    page: "reviews",
    id: 10,
    gender: "male",
    product: ["st", "st-ot", "iwl-ot", "wp-ot", "os-ot"],
    name: "Nick F.",
    location: "Jacksonville, FL",
    image: reviewerMale1,
    text: `"I used to think GLP-1 weight loss wasn’t for me. I've already lost 32 pounds—and counting! So grateful for this affordable, effective option."`,
  },
  {
    page: "reviews",
    id: 11,
    gender: "female",
    product: ["tr", "tr-ot"],
    name: "Stefani G.",
    location: "Miami, FL",
    image: reviewerFemale1,
    text: `"I’ve been  losing weight, I feel so much better overall—more energy, more confidence—and it’s way more affordable than the big-name brands. Honestly, I wish I had started sooner."`,
  },
  {
    page: "reviews",
    id: 12,
    gender: "male",
    product: ["tr", "tr-ot"],
    name: "Will A.",
    location: "Orlando, FL",
    image: reviewerMale1,
    text: `"Started tirzepatide and I’m so happy I did. It’s easy to do and i feel better. The weight’s coming off and my blood sugar’s more stable. So far have lost 22 pounds and hoping to reach my goal weight by fall!"`,
  },
  {
    page: "ed-reviews",
    id: 13,
    gender: "male",
    product: ["ed-ot"],
    name: "James R.",
    location: "Miami, FL",
    image: reviewerJames,
    text: `"I was tired of subscription companies charging me. This was simple. I ordered once, it worked, and I could relax knowing I only pay when I need it."`,
  },
  {
    page: "ed-reviews",
    id: 14,
    gender: "male",
    product: ["ed-ot"],
    name: "Carlos D.",
    location: "Chicago, IL",
    image: reviewerMale1,
    text: `"I’d been struggling with ED for months and felt embarrassed to even talk about it. This treatment brought my confidence back. I feel steady and reliable again."`,
  },
  {
    page: "amh-reviews",
    id: 15,
    gender: "male",
    product: ["amh-ot"],
    name: "James R.",
    location: "Miami, FL",
    image: reviewerJames,
    text: `"I was overwhelmed and stuck. Once I started taking sertraline it helped me feel steady, motivated, and more confident every single day. Life-changing"`,
  },
  {
    page: "amh-reviews",
    id: 16,
    gender: "female",
    product: ["amh-ot"],
    name: "Sara G.",
    location: "Tampa, FL",
    image: reviewerFemale1,
    text: `"Within weeks, my stress dropped, my focus came back, and I finally felt in control again. HolaVida made it simple and private - exactly what I needed."`,
  },
  {
    page: "aa-reviews",
    id: 17,
    gender: "female",
    product: ["aa-ot"],
    name: "Sofia R.",
    location: "Tampa, FL",
    image: reviewerSofia,
    text: `"Fine lines were creeping in and my skin always looked tired. After using this cream, my skin feels smoother, brighter, and so much healthier."`,
  },
  {
    page: "aa-reviews",
    id: 18,
    gender: "female",
    product: ["aa-ot"],
    name: "Amanda T.",
    location: "Hollywood, FL",
    image: reviewerAmanda,
    text: `"I’ve tried so many products with zero results. This one actually made a difference — my skin looks firmer, my dark spots faded, and I feel confident again."`,
  },
  {
    page: "aa-reviews",
    id: 19,
    gender: "female",
    product: ["ac-ot"],
    name: "Sofia R.",
    location: "Tampa, FL",
    image: reviewerSofia,
    text: `"My breakouts were constant and nothing helped. After starting this, my skin looks smoother, less red, and my pores don’t feel clogged anymore."`,
  },
  {
    page: "aa-reviews",
    id: 20,
    gender: "female",
    product: ["ac-ot"],
    name: "James R.",
    location: "Miami, FL",
    image: reviewerJames,
    text: `"I’ve wasted so much money on acne products. This one actually made a difference—fewer pimples, lighter dark spots, and my skin looks clearer every week."`,
  },
  {
    page: "aa-reviews",
    id: 21,
    gender: "female",
    product: ["ro-ot"],
    name: "Sofia R.",
    location: "Tampa, FL",
    image: reviewerSofia,
    text: `"My skin would flush constantly and feel irritated. After using this treatment, my redness has noticeably calmed down and my skin feels so much more comfortable and even."`,
  },
  {
    page: "aa-reviews",
    id: 22,
    gender: "female",
    product: ["ro-ot"],
    name: "Amanda T.",
    location: "Hollywood, FL",
    image: reviewerAmanda,
    text: `"I’ve tried so many products that only made my rosacea worse. This one actually helped reduce my flare-ups. The redness has softened and I finally feel confident without heavy makeup."`,
  },
  {
    page: "bb-reviews",
    id: 23,
    gender: "Female",
    product: ["bb-ot"],
    name: "Sofía R.",
    location: "Tampa, FL",
    image: reviewerSofia,
    text: `"My heart would race and my mind wouldn't stop spiraling before stressful situations. After using this treatment, I finally feel in control and can actually be present in the moment."`,
  },
  {
    page: "bb-reviews",
    id: 24,
    gender: "Female",
    product: ["bb-ot"],
    name: "Amanda T.",
    location: "Hollywood, FL",
    image: reviewerAmanda,
    text: `"I've tried so many things that barely took the edge off. This actually worked. I felt calmer without feeling foggy or out of it. I finally feel like myself again."`,
  },
  {
    page: "sl-reviews",
    id: 25,
    gender: "Female",
    product: ["sl-ot"],
    name: "Sofía R.",
    location: "Tampa, FL",
    image: reviewerSofia,
    text: `"My mind wouldn't stop racing the second my head hit the pillow. After using this treatment, I finally fall asleep faster and actually stay asleep through the night."`,
  },
  {
    page: "sl-reviews",
    id: 26,
    gender: "Female",
    product: ["sl-ot"],
    name: "Amanda T.",
    location: "Hollywood, FL",
    image: reviewerAmanda,
    text: `"I've tried melatonin, supplements, everything — nothing really worked. This actually did. I wake up feeling rested without feeling groggy or out of it. I finally feel like myself again."`,
  },
];
